<h1>Resources</h1>
<div class="left-offset">
  A link to resources has been opened in a new window. If you do not automatically see this new window, please enable pop-ups for the website, and click on the link below: <br />
  <a [href]="madcapResourceUrl" target="_blank" rel="noreferrer noopener">Link to Resources</a>
</div>

